import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const BRAND = "Monster Truck Lord";

const TITLES = {
  "/": `${BRAND} — Official Merch`,
  "/shop": `Shop — ${BRAND}`,
  "/monster-shirts": `Monster Shirts — ${BRAND}`,
  "/press": `Press & Rebranding — ${BRAND}`,
  "/cart": `Your Cart — ${BRAND}`,
  "/checkout": `Checkout — ${BRAND}`,
  "/order/success": `Order Confirmed — ${BRAND}`,
  "/login": `Log In — ${BRAND}`,
  "/register": `Create Account — ${BRAND}`,
  "/account": `My Account — ${BRAND}`,
  "/wishlist": `Wishlist — ${BRAND}`,
  "/admin": `Admin — ${BRAND}`,
};

export function TitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/product/")) return; // ProductDetail sets its own title
    document.title = TITLES[pathname] || BRAND;
  }, [pathname]);
  return null;
}
